var _title, _desc, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "user")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "18.6155386%",
    y1: "22.8839365%",
    x2: "81.5718671%",
    y2: "59.107771%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.68666392%",
    y1: "28.8766247%",
    x2: "95.3140223%",
    y2: "71.1315587%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,0 C114.844,0 0,114.844 0,256 C0,397.156 114.844,512 256,512 C397.156,512 512,397.156 512,256 C512,114.844 397.156,0 256,0 Z",
    id: "Path",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,21.333 C385.396,21.333 490.667,126.604 490.667,256 C490.667,307.508 473.789,355.038 445.546,393.781 C443.079,392.176 440.641,390.712 438.167,389.437 C395.417,367.49 329.104,341.333 256,341.333 C182.896,341.333 116.583,367.49 73.823,389.448 C71.356,390.718 68.921,392.178 66.455,393.781 C38.212,355.036 21.333,307.508 21.333,256 C21.333,126.604 126.604,21.333 256,21.333 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,490.667 C185.839,490.667 122.944,459.559 79.905,410.594 C81.132,409.851 82.369,409.043 83.583,408.417 C124.239,387.542 187.156,362.667 256,362.667 C324.844,362.667 387.76,387.542 428.406,408.407 C429.626,409.037 430.866,409.846 432.096,410.593 C389.056,459.557 326.161,490.667 256,490.667 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6A6A6A",
    cx: 256,
    cy: 192,
    r: 128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.73,469.59 C383.197,455.668 410.227,435.472 432.096,410.593 C430.866,409.846 429.626,409.037 428.406,408.407 C387.76,387.542 324.843,362.667 256,362.667 C252.704,362.667 249.499,362.981 246.232,363.091 L352.73,469.59 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 256,
    cy: 192,
    r: 106.667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.184,102.263 C317.36,113.673 320,125.828 320,138.667 C320,197.482 272.15,245.334 213.333,245.334 C192.256,245.334 172.712,238.995 156.149,228.404 C171.105,269.265 210.021,298.667 255.999,298.667 C314.815,298.667 362.666,250.815 362.666,192 C362.666,154.26 342.841,121.229 313.184,102.263 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,0 C114.844,0 0,114.844 0,256 C0,397.156 114.844,512 256,512 C397.156,512 512,397.156 512,256 C512,114.844 397.156,0 256,0 Z",
    id: "Path",
    fillOpacity: 0.2,
    fill: "url(#linearGradient-2)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.5d7efb38.svg";
export { ForwardRef as ReactComponent };